import { Component, OnInit, Input } from '@angular/core';
import { PreparationBasic } from 'src/app/models/catalogs-model/preparation.model';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';
import { PreparationsService } from 'src/app/services/catalogs-services/preparations-services/preparations.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { MatDialog } from '@angular/material';
import { ImageDialogComponent } from '../../shared-components/image-dialog/image-dialog.component';
import { MultimediaManagerComponent } from 'src/app/modules/multimedia-manager/multimedia-manager/multimedia-manager.component';

@Component({
  selector: 'app-catalogs-preparation-photo-editor-card',
  templateUrl: './catalogs-preparation-photo-editor-card.component.html',
  styleUrls: ['./catalogs-preparation-photo-editor-card.component.scss']
})
export class CatalogsPreparationPhotoEditorCardComponent implements OnInit {

  @Input() preparation: PreparationBasic;
  @Input() title: string;
  @Input() width: string;
  @Input() height: string;
  showSpinner: boolean;

  constructor(private spinnerService: SpinnerService,
              private dialog: MatDialog,
              private snackbarService: SnackBarService,
              private preparationsService: PreparationsService) { }

  ngOnInit() {
    this.showSpinner = false;
  }

  public updateImagePreparation(imageUrl) {
    this.showSpinner = true;
    this.spinnerService.show('preparation-image-spinner');
    this.preparationsService.updatePreparationImage(this.preparation.InternalId, imageUrl).subscribe(
      (res) => {
        this.preparationsService.refreshPreparation();
        this.showSpinner = false;
        this.spinnerService.hide('preparation-image-spinner');
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.preparationsService.refreshPreparations();
        this.showSpinner = false;
        this.spinnerService.hide('preparation-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public deleteAsset() {
    this.showSpinner = true;
    this.spinnerService.show('preparation-image-spinner');
    this.preparationsService.updatePreparationImage(this.preparation.InternalId, null).subscribe(
      (res) => {
        this.preparationsService.refreshPreparation();
        this.showSpinner = false;
        this.spinnerService.hide('preparations-image-spinner');
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.preparationsService.refreshPreparations();
        this.showSpinner = false;
        this.spinnerService.hide('preparations-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public zoom() {
    const dialogRef = this.dialog.open(ImageDialogComponent, { data: { image: this.preparation.Image, info: { title: this.title, subtitle: this.width + 'x' + this.height }}});
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        if (res === 'upload') {
          this.uploadPhotoClicker();
        } else if (res === 'delete') {
          this.deleteAsset();
        }
      }
    });
  }

  public uploadPhotoClicker() {
    const dialogRef = this.dialog.open(MultimediaManagerComponent, { data: { multi: false, cropper: { width: 250, height: 250 } } });
    dialogRef.beforeClosed().subscribe(
      (result) => {
        if (result) {
          this.updateImagePreparation(result[0].Url);
        }

      }
    );
  }
}
